import {
  MARKET_MODES,
  MARKET_MODE_STATUS,
  Market
} from '../market';

const MUSIC_FAQ = [
  {
    title: 'Что делает Boostclick?',
    isH3: false,
    text:
      <p>
        Boostclick — это платформа, где где вы размещаете задания для слушателей.
        <br />
        Пользователи добровольно переходят к вашему треку в VK Музыке, слушают его и при желании выполняют действия: лайк, добавление, переход к артисту. После этого они заполняют мини-отчет — это обратная связь, которую вы можете использовать для оценки восприятия.
      </p>
  },
  {
    title: 'Кто выполняет задания?',
    isH3: false,
    text:
      <p>
        Реальные пользователи из России с аккаунтами VK Музыки. Они читают инструкцию, запускают ваш трек и дают обратную связь через форму отчета. Вы можете задать, какие действия ожидаются (прослушивание, переходы и т.д.), но итоговое выполнение зависит от пользователя.
      </p>
  },
  {
    title: 'Какие действия может выполнить слушатель?',
    isH3: false,
    text:
      <div>
        Вы можете предложить слушателям:
        <br />
        <ul>
          <li>Перейти по ссылке на ваш трек или альбом</li>
          <li>Послушать часть трека (например, 1–3 минуты)</li>
          <li>При желании — лайкнуть, добавить в «Мои треки»</li>
          <li>Перейти к альбому или странице исполнителя</li>
          <li>Ответить на контрольный вопрос (например: «Какой жанр трека?»)</li>
        </ul>
      </div>
  },
  {
    title: 'Помогает ли это продвижению?',
    isH3: false,
    text:
      <p>
        Boostclick не гарантирует результатов в чартах или алгоритмах.
        Но вовлеченность реальных слушателей, естественное прослушивание и обратная связь могут быть полезны для понимания интереса аудитории и потенциально влиять на поведенческие сигналы.
      </p>
  },
  {
    title: 'Это подходит для альбомов?',
    isH3: false,
    text:
      <p>
        Да. Вы можете продвигать плейлисты, синглы или альбомы. Укажите ссылку и действия, которые важно протестировать: сколько треков слушают, что запоминается, и т.д.
      </p>
  },
  {
    title: 'Что включено в отчет?',
    isH3: false,
    text:
    <div>
        Вы получаете:
        <br />
        <ul>
          <li>Подтверждение выполнения задания</li>
          <li>Ответ на контрольный вопрос</li>
          <li>Краткий комментарий слушателя (если включено)</li>
        </ul>
      </div>
  },
];

const STEP_TWO_TITLE_FAQ = <p>
  Почему при добавлении одного действия в калькуляторе появляются дополнительные действия?
  <br />
  <br />
  Сервис формирует уникальные сценарии для каждого слушателя, и каждый сценарий начинается для нового слушателя с перехода на страницу по переданной вами ссылке.
</p>;

const ACTIONS = [
  {
    type: "ALWAYS.OPEN",
    icon: "open",
    iconHome: "home-open",
    title: "Открыть сайт или приложение VK Музыка",
    initialShare: 1,
  },
  {
    type: "ALWAYS.SEARCH",
    icon: "search",
    iconHome: "home-search",
    title: "Найти продвигаемый трек",
    initialShare: 1,
  },
  {
    type: "ALWAYS.LISTEN",
    icon: "headphones",
    iconHome: "home-headphones",
    title: "Прослушать трек без перемотки",
    titleComment: "от 1 до 3 мин",
    initialShare: 1,
  },

  {
    type: "MAIN.FAVORITE",
    icon: "heart",
    iconHome: "home-add-track",
    title: "Добавить трек в свой плейлист",
    initialShare: 0.7,
    activityType: "Плейлист",
  },
  {
    type: "MAIN.SUBSCRIBE",
    icon: "heart",
    iconHome: "home-heart",
    title: "Подписаться на исполнителя",
    initialShare: 0.3,
    activityType: "Подписка",
  },

  {
    type: "EXTRA.ARTIST",
    icon: "headphones",
    iconHome: "home-headphones",
    title: "Послушать другой трек исполнителя",
    initialShare: 0.4,
  },
  {
    type: "EXTRA.ALBUM",
    icon: "headphones",
    iconHome: "home-headphones",
    title: "Пролистать треки в альбоме",
    initialShare: 0.6,
  },
];

const ACTIONS_PRESAVES = [
  {
    type: "ALWAYS.LINK",
    icon: "open",
    iconHome: "home-open",
    title: "Перейти по ссылке на пресейв",
    initialShare: 1,
  },
  {
    type: "EXTRA.ARTIST",
    icon: "people",
    iconHome: "home-people",
    title: "Открыть карточку исполнителя",
    initialShare: 0.7,
  },
  {
    type: "EXTRA.TRACK",
    icon: "headphones",
    iconHome: "home-headphones",
    title: "Послушать другой трек исполнителя",
    initialShare: 0.3,
  },
  {
    type: "MAIN.PRESAVE",
    icon: "bell",
    iconHome: "home-bell",
    title: "Добавить трек/альбом в пресейв",
    initialShare: 1,
    activityType: "Пресейв",
  },
];

const ACTIONS_LISTENS = [
  {
    type: "VIEW.ARTIST",
    icon: "people",
    iconHome: "home-people",
    title: "Прослушка +\nперейти к исполнителю",
    titleComment: "без перемотки",
  },
  {
    type: "VIEW.ALBUM",
    icon: "open",
    iconHome: "home-open",
    title: "Прослушка +\nперейти к альбому",
    titleComment: "без перемотки",
  },
  {
    type: "VIEW.TRACK",
    icon: "headphones",
    iconHome: "home-headphones",
    title: "Прослушка +\nоткрыть другой трек исполнителя",
    titleComment: "без перемотки",
  },
].map(action => ({
  ...action,
  initialShare: 1 / 3,
  subactions: 2,
  itemTitle: 'прослушка',
}));

const CHAIN_PRICE = 25;
const CHAIN_STEPS = ACTIONS.filter(
  action => action.type.startsWith("ALWAYS.")
).length + 2;

const MAIN_PAGE_TITLES = [
  {
    iconHome: "home-heart",
    title: "Поставить лайк треку",
    path: "/prodvizhenie-trekov-vkmusic",
    target: '_self',
    statusForHomePage: MARKET_MODE_STATUS.NEW,
  },
  {
    iconHome: "home-headphones",
    title: "Прослушать трек",
    titleComment: "от 1-3 минут",
    path: "/prodvizhenie-trekov-vkmusic",
    target: '_self',
  },
  {
    iconHome: "home-disk",
    title: "Перейти к альбому",
    titleComment: "от 30 сек",
    path: "/prodvizhenie-trekov-vkmusic",
    target: '_self',
  },
  {
    iconHome: "home-headphones",
    title: "Пролистать треки в альбоме",
    path: "/prodvizhenie-trekov-vkmusic",
    target: '_self',
  },
  {
    iconHome: "home-track-artist",
    title: "Перейти к исполнителям",
    titleComment: "от 30 сек",
    path: "/prodvizhenie-trekov-vkmusic",
    target: '_self',
  },
  {
    iconHome: "home-headphones",
    title: "Послушать другой трек исполнителя",
    path: "/prodvizhenie-trekov-vkmusic",
    target: '_self',
  },
  {
    iconHome: "home-search",
    title: "Найти продвигаемый трек",
    path: "/prodvizhenie-trekov-vkmusic",
    target: '_self',
  },
  {
    iconHome: "home-open",
    title: "Открыть VK.Музыку*",
    path: "/prodvizhenie-trekov-vkmusic",
    target: '_self',
  },
  {
    iconHome: "home-add-track",
    title: "Добавить в плейлист / мои треки",
    path: "/prodvizhenie-trekov-vkmusic",
    target: '_self',
  }
];

const VKMUSIC_KEYWORDS = [
  'ВК Музыка', 'VK Музыка', 'vk', 'vk music'
];

class VkMusicClass extends Market {
  id = 'vkmusic';
  host = 'music.vk.com';
  hostsList = [];
  url = 'https://music.vk.com/';

  title = 'VK.Музыка*';

  isMarketplace = false;
  isMusicPlatform = true;

  icon = "vkmusic";
  titlePlaces = 'VK.Музыка*';
  statusForHomePage = MARKET_MODE_STATUS.NEW;
  mainPageTitles = MAIN_PAGE_TITLES;

  categories = [];

  chainsPerDayNormal = 400 / 30;
  chainPrice = CHAIN_PRICE;
  chainsMin = 20;
  chainsMax = 400;

  chainsDefault = 30;
  reviewPrice = 0;
  chainsStep = 10;
  viewsStep = 50;

  viewPrice = 15;
  viewsMax = 1000;
  viewsPerDay = 100;

  keywords = VKMUSIC_KEYWORDS;

  targetLinkComment = <span>Укажите ссылку на трек</span>;
  targetLinkCommentShort = <span>Укажите ссылку на трек</span>;

  modes = [
    {
      id: MARKET_MODES.CHAINS,
      title: 'Активность',
      navigateTitle: 'Активность: прослушивания, лайки, вовлеченность',
      path: '/prodvizhenie-trekov-vkmusic',
      rating: 0.10,
      icon: "headphones",
      iconForHomePage: "home-action",
      status: MARKET_MODE_STATUS.NEW,
      meta: {
        title: `Прослушивание и продвижение треков в VK Музыке — от ${CHAIN_PRICE / CHAIN_STEPS} руб.`,
        description: 'Boostclick помогает привлекать реальных слушателей VK Музыки: прослушивания, лайки и обратная связь без ботов.',
        canonical: '/prodvizhenie-trekov-vkmusic',
      },
      intro: {
        title: 'Продвижение треков в VK Музыке*',
        comment: 'Через прослушивания от живой аудитории',
        points: [
          'Слушатели из России с аккаунтами VK*',
          'Проверка интереса к треку и артисту',
          'Обратная связь в формате отчетов от слушателей',
          'Повышение вовлеченности и интереса',
          'Без ботов',
        ]
      },
      howItWorks: [
        'Распределите активности',
        'Укажите ссылку на страницу или группу',
        'Сервис создаст задания для исполнителей',
        'Исполнители выполнят задания и пришлют отчеты',
        'Проверьте отчеты, если все верно примите их, если есть ошибки, то смените исполнителя',
      ],
      stepPhrase1: 'Настройте параметры проекта',
      stepPhrase2: 'Детали заданий для органического поиска слушателями',
      stepTwoTitleFaq: STEP_TWO_TITLE_FAQ,
      calculatorTitle: 'Заказать продвижение треков в ВК Музыке*',
      titleFAQ: "Вопрос-ответ: продвижение треков в VK Музыке*",
      faq: MUSIC_FAQ,
      actions: ACTIONS,
      notice: [
        '* Сервис сгенерирует уникальные цепочки действий с учетом поисковых запросов',
        'Каждый слушатель получит индивидуальное задание, что гарантирует разное поведение пользователей на вашем треке',
        'Скорость и сложность зависят от объема заданий и выбранных условий',
      ]
    },
    {
      id: MARKET_MODES.CHAINS,
      title: 'Пресейв',
      navigateTitle: 'Пресейв треков',
      path: '/prodvizhenie-trekov-vkmusic-presave',
      rating: 0.099,
      icon: "headphones",
      iconForHomePage: "home-action",
      status: MARKET_MODE_STATUS.NEW,
      meta: {
        title: `Пресейв треков в VK Музыке — от ${CHAIN_PRICE / CHAIN_STEPS} руб.`,
        description: 'Boostclick помогает привлекать реальных слушателей VK Музыки: пресейвы и обратная связь без ботов',
        canonical: '/prodvizhenie-trekov-vkmusic-presave',
      },
      intro: {
        title: 'Пресейв треков в VK Музыке*',
        comment: 'Через переходы от живой аудитории',
        points: [
          'Слушатели из России с аккаунтами VK*',
          'Проверка интереса к треку и артисту',
          'Обратная связь в формате отчетов от слушателей',
          'Повышение вовлеченности и интереса',
          'Без ботов',
        ]
      },
      howItWorks: [
        'Распределите активности',
        'Укажите ссылку на страницу или группу',
        'Сервис создаст задания для исполнителей',
        'Исполнители выполнят задания и пришлют отчеты',
        'Проверьте отчеты, если все верно примите их, если есть ошибки, то смените исполнителя',
      ],
      stepPhrase1: 'Настройте параметры проекта',
      stepPhrase2: 'Детали заданий для переходов и модерации',
      stepTwoTitleFaq: STEP_TWO_TITLE_FAQ,
      calculatorTitle: 'Заказать пресейв треков в ВК Музыке*',
      titleFAQ: "Вопрос-ответ: пресейв треков в VK Музыке*",
      faq: MUSIC_FAQ,
      actions: ACTIONS_PRESAVES,
      notice: [
        '* Сервис сгенерирует уникальные цепочки действий с учетом поисковых запросов',
        'Каждый слушатель получит индивидуальное задание, что гарантирует разное поведение пользователей на вашем треке',
        'Скорость и сложность зависят от объема заданий и выбранных условий',
      ]
    },
    {
      id: MARKET_MODES.VIEWS,
      title: 'Прослушка',
      navigateTitle: 'Прослушивание треков',
      path: '/prodvizhenie-trekov-vkmusic-proslushka',
      rating: 0.099,
      icon: "headphones",
      iconForHomePage: "home-action",
      status: MARKET_MODE_STATUS.NEW,
      meta: {
        title: `Прослушивание треков в VK Музыке — от ${this.viewPrice} руб.`,
        description: 'Boostclick помогает привлекать реальных слушателей VK Музыки: прослушивания и обратная связь без ботов',
        canonical: '/prodvizhenie-trekov-vkmusic-proslushka',
      },
      intro: {
        title: 'Прослушивание треков в VK Музыке*',
        comment: 'Через переходы от живой аудитории',
        points: [
          'Слушатели из России с аккаунтами VK*',
          'Проверка интереса к треку и артисту',
          'Обратная связь в формате отчетов от слушателей',
          'Повышение вовлеченности и интереса',
          'Без ботов',
        ]
      },
      howItWorks: [
        'Распределите активности',
        'Укажите ссылку на страницу или группу',
        'Сервис создаст задания для исполнителей',
        'Исполнители выполнят задания и пришлют отчеты',
        'Проверьте отчеты, если все верно примите их, если есть ошибки, то смените исполнителя',
      ],
      stepPhrase1: 'Настройте параметры проекта',
      stepPhrase2: 'Детали заданий для переходов и модерации',
      stepTwoTitleFaq: STEP_TWO_TITLE_FAQ,
      calculatorTitle: 'Заказать прослушивание треков в ВК Музыке*',
      titleFAQ: "Вопрос-ответ: прослушивание треков в VK Музыке*",
      faq: MUSIC_FAQ,
      actions: ACTIONS_LISTENS,
      notice: [
        '* Сервис сгенерирует уникальные цепочки действий с учетом поисковых запросов',
        'Каждый слушатель получит индивидуальное задание, что гарантирует разное поведение пользователей на вашем треке',
        'Скорость и сложность зависят от объема заданий и выбранных условий',
      ]
    },
  ];

  actionsMap = [...ACTIONS, ...ACTIONS_PRESAVES, ...ACTIONS_LISTENS].reduce((map, action) => {
    map[action.type] = action; return map;
  }, {});

  emptyUrlStr = 'Укажите ссылку на трек';
  invalidUrlStr = 'Укажите корректную ссылку на трек';
}

const VkMusic = new VkMusicClass();
export default VkMusic;
